import {Injectable} from "@angular/core";
import {NgxIndexedDBService} from "ngx-indexed-db";
import {Observable} from "rxjs";
import {IDbAllegato} from "@core/models/interfaces/indexeddb.interface";
import {INDEXED_DB_KEY} from "@shared/constants/shared.constants";
import {take} from "rxjs/operators";
import {nanoid} from "nanoid";

@Injectable({
  providedIn: 'root'
})
export class IndexedDBService {

  static readonly idPrefix = 'confcooperative_allegato_key_'

  constructor(
    private ngxIndexedDb: NgxIndexedDBService
  ) {  }

  add(file: File): Observable<IDbAllegato> {
    const allegato = {
      file,
      id: IndexedDBService.idPrefix + nanoid()
    }
    return this.ngxIndexedDb.add<IDbAllegato>(INDEXED_DB_KEY, allegato).pipe(take(1));
  }

  getByID(id: string): Observable<IDbAllegato> {
    return this.ngxIndexedDb.getByID<IDbAllegato>(INDEXED_DB_KEY, id).pipe(take(1));
  }

  deleteByKey(id: string): Observable<boolean> {
    return this.ngxIndexedDb.deleteByKey(INDEXED_DB_KEY, id).pipe(take(1));
  }

  bulkGet(ids: string[]): Observable<IDbAllegato[]>{
    return <Observable<IDbAllegato[]>>this.ngxIndexedDb.bulkGet(INDEXED_DB_KEY, ids).pipe(take(1));
  }

  bulkDelete(ids: string[]): Observable<any>{
    return this.ngxIndexedDb.bulkDelete(INDEXED_DB_KEY, ids).pipe(take(1));
  }

  bulkAdd(allegati: IDbAllegato[]): Observable<any> {

    // aggiungo id prefix e rimuovo parametri che non servono
    allegati = allegati.map(a => ({
      file: a.file,
      id: IndexedDBService.idPrefix + a.id
    }))

    return this.ngxIndexedDb.bulkAdd(INDEXED_DB_KEY, allegati).pipe(take(1));
  }

}
